import type { ReactNode, WheelEvent } from "react";

interface ScrollablePreviewCellProps {
  children: ReactNode;
}

/** Matches StructuredSearchInfiniteGridShell rowHeight (68) minus vertical padding. */
const PREVIEW_CELL_MAX_HEIGHT_CLASS = "max-h-[60px]";

const handleWheel = (event: WheelEvent<HTMLDivElement>) => {
  const element = event.currentTarget;
  const { scrollTop, scrollHeight, clientHeight } = element;
  if (scrollHeight <= clientHeight) {
    return;
  }

  const delta = event.deltaY;
  const atTop = scrollTop <= 0;
  const atBottom = scrollTop + clientHeight >= scrollHeight - 1;
  const scrollingUp = delta < 0;
  const scrollingDown = delta > 0;

  if ((scrollingUp && !atTop) || (scrollingDown && !atBottom)) {
    event.stopPropagation();
  }
};

export const ScrollablePreviewCell = ({ children }: ScrollablePreviewCellProps) => (
  <div
    className={`${PREVIEW_CELL_MAX_HEIGHT_CLASS} scrollbar-hide w-full min-w-0 overflow-y-auto whitespace-normal break-words py-1 text-sm leading-5`}
    onWheel={handleWheel}
  >
    {children}
  </div>
);
